import { observer } from "mobx-react-lite";
import React, { useState } from "react"
import { useEffect } from "react";
import { CSVLink } from "react-csv";
import { Table, Header, Checkbox, CheckboxProps, Input, InputOnChangeData, Popup, Dropdown, Icon, DropdownProps, Label } from 'semantic-ui-react'
import agent from "../../app/api/agent";
import { _SumRangePick } from "../../app/lib/CommonData";
import { _GetBonusText, _getWindowDimensions } from "../../app/lib/CommonFunctions";
import LoadingComponent from "../../app/lib/LoadingComponent";
import { SumHistory } from "../../app/models/IDayResult";
import { useStore } from "../../app/store/store";

export default observer(function AnalysisBySum() {

    const [loading, setLoading] = useState(true);
    const [useBonus, setUseBonus] = useState(true);
    const [windowDimensions, setWindowDimensions] = useState(_getWindowDimensions());
    const [noOfDraw, setNoOfDraw] = useState(30);
    const [systemPick, setSystemPick] = useState(7);
    const {userStore } = useStore();
    const [sumLength, setSumLength] = useState(10)
    const [noOfSteps, setNoOfSteps] = useState(50)
    const [data, setData] = useState<SumHistory[]>([]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(_getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const onBonusChanged = (event: React.FormEvent<HTMLInputElement>, data: CheckboxProps) => {
        setUseBonus(data.checked!);
        setLoading(true);
    }

    const pickDropDownChanged = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        setSystemPick(parseInt(data.value + ""));
    }

    const onDrawNoChanged = (event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        setNoOfDraw(parseInt(data.value));
    }

    const onStepChanged = (event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        setNoOfSteps(parseInt(data.value));
    }

    
    useEffect(() => {
        agent.DrawTotoResult.getSumHistory(useBonus, systemPick, noOfSteps, noOfDraw).then((response) => {
            setLoading(false);
            setData(response);
        });
    }, [useBonus, systemPick, noOfSteps, noOfDraw]);



    if (!userStore.isLogged) {
        return (<Header>Not Authorized</Header>)
    }

    if (loading) {
        return (<LoadingComponent></LoadingComponent>);
    }


    return (
        <div style={{ overflowX: "auto", height: windowDimensions.height - 160 }}>
            <Table celled unstackable selectable singleLine size="small">
                <Table.Header>
                    <Table.Row>
                        <Table.Row key="Hdr1">
                            <Table.HeaderCell>
                                <Popup style={{ zIndex: 23 }} content="Please select group" position="top right" trigger={
                                    <Dropdown fluid style={{ zIndex: 23 }}
                                        selection data-moveup="false"
                                        onChange={pickDropDownChanged}
                                        placeholder="Select Group"
                                        options={_SumRangePick}
                                        defaultValue={systemPick}
                                        direction="right"
                                    />
                                }>
                                </Popup>
                            </Table.HeaderCell>

                            <Table.HeaderCell>
                                <Input  Style="width:100px;text-align:right" fluid onChange={onDrawNoChanged} maxLength={4} onKeyPress={(event: any) => {
                                    if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }} placeholder="No of Draws" defaultValue={noOfDraw}></Input>

                            </Table.HeaderCell>


                            <Table.HeaderCell textAlign="center" colSpan={sumLength} >
                                <Header>ANALYSIS BY SUM Numbers</Header>
                            </Table.HeaderCell>
                            <Table.HeaderCell textAlign="center" rowSpan="3">
                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row key="Hdr2">
                            <Table.HeaderCell>
                                <Checkbox toggle label={_GetBonusText(useBonus)} defaultChecked={useBonus} onChange={onBonusChanged} />
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <Input Style="width:100px;text-align:right"  fluid onChange={onStepChanged} maxLength={3} onKeyPress={(event: any) => {
                                    if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }}
                                    placeholder="No of Steps" defaultValue={noOfSteps}>
                                </Input>
                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row key="Hdr3">
                            <Table.HeaderCell>
                                Draw Date
                            </Table.HeaderCell>

                        </Table.Row>
                    </Table.Row>
                </Table.Header>
            </Table>
        </div>
    );
});